import { createFileRoute } from "@tanstack/react-router"
import { WidgetPhoneMockup } from "modules/campaigns/components/Sections/triggers/widget/iframe"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/widget/phone-mockup")({
  component: WidgetPhoneMockup,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("campaigns.templates.widget.tabs.phoneMockup"),
    })
  },
})
